import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Pure Bearer-token auth (no cross-origin credentialed requests).
// Works identically across custom domains (inafinvestigacion.com),
// preview URLs, and local dev — without needing cookies.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Attach Bearer token from localStorage as a secondary auth channel
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("inaf_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Persist access token from custom header if provided by backend
api.interceptors.response.use(
  (response) => {
    const hdr = response.headers?.["x-access-token"];
    if (hdr) {
      localStorage.setItem("inaf_token", hdr);
    }
    return response;
  },
  (err) => Promise.reject(err)
);

export function formatApiError(detail) {
  if (detail == null) return "Ha ocurrido un error. Intenta nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
